import { createSlice } from '@reduxjs/toolkit'
export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    isAuthenticated: false,
    loading: false,
    wallets: [],
    dataDuration: {
      id: 7,
      value: 'Last 7 Days',
    },
    showAddWallet: false,
    selectedToken: null,
    selectedContract: null,
    selectedChain: null,  // Add support for existing chain
    selectedBenchmark: 'ETH', // Add default benchmark
    notificationData: [],
    stripeConfirmation: {},
    topTokenPriceChange: [],
    isNewNotification: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
      state.isAuthenticated = action.payload ? true : false
    },
    isLoading: (state, action) => {
      state.loading = action.payload
    },
    addWallet: (state, action) => {
      if (action.payload) state.wallets.push(action.payload)
    },
    setDuration: (state, action) => {
      state.dataDuration = action.payload
    },
    setShowAddWallet: (state, action) => {
      state.showAddWallet = action.payload
    },
    setAllWallets: (state, action) => {
      state.wallets = action.payload
    },
    setSelectedToken: (state, action) => {
      state.selectedToken = action.payload
    },
    setSelectedContract: (state, action) => {
      if (action.payload) {
        state.selectedContract = action.payload.contract;
        state.selectedChain = action.payload.chain;
      } else {
        state.selectedContract = null;
        state.selectedChain = null;
      }
    },
    setSelectedChain: (state, action) => {
      state.selectedChain = action.payload;
    },
    setSelectedBenchmark: (state, action) => {
      state.selectedBenchmark = action.payload
    },
    resetUserData: (state) => {
      state.user = null
      state.isAuthenticated = false
      state.loading = false
      state.wallets = []
      state.dataDuration = {
        id: 7,
        value: 'Last 7 Days',
      }
      state.showAddWallet = false
      state.selectedToken = null
      state.selectedBenchmark = 'ETH'
    },
    setNotificationData: (state, action) => {
      state.notificationData = action?.payload
    },
    setStripeConfirmation: (state, action) => {
      if (!action?.payload) {
        state.stripeConfirmation = {
          ...state.stripeConfirmation,
          max_wallets: 1,
        }
      } else {
        state.stripeConfirmation = action?.payload
      }
    },
    setTopTokenPriceChange: (state, action) => {
      state.topTokenPriceChange = action?.payload
    },
    setIsNewNotification: (state, action) => {
      state.isNewNotification = action?.payload
    },
  },
})
export const {
  setUser,
  isLoading,
  addWallet,
  setDuration,
  setShowAddWallet,
  setAllWallets,
  setSelectedToken,
  setSelectedContract,
  setSelectedChain,
  setSelectedBenchmark,
  resetUserData,
  setNotificationData,
  setStripeConfirmation,
  setTopTokenPriceChange,
  setIsNewNotification,
} = userSlice.actions
export default userSlice.reducer